import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=4b83f746&scoped=true"
var script = {}
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=4b83f746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b83f746",
  null
  
)

export default component.exports